var StoresListItemModel = require('./stores-list-item');

var StoresListModel = Backbone.Epoxy.Model.extend({
  initialize: function() { },

  defaults: {
    store: null,
    zipCode: '',
    isInitialized: false,
    isStoreConnected: false,
    hasItems: false,
    stores: new Backbone.Collection(null, { model: StoresListItemModel }),
  },

  computeds: {
    isReady: {
      deps: ['isInitialized', 'isStoreConnected', 'hasItems'],
      get: function() {
        return this.get('isInitialized') &&
          this.get('isStoreConnected') &&
          this.get('hasItems');
      }
    },
    isEmpty: {
      deps: ['hasItems'],
      get: function() {
        return !this.get('hasItems');
      }
    },
  },

  validation: { },

  bindModel: function(data) {
    this.set('isInitialized', true);

    this.get('stores').reset();
    this.set('isStoreConnected', ((data || {}).success == true));
    this.set('hasItems', false);

    if (!this.get('isStoreConnected')) {
      return;
    }

    data.stores.forEach(it => {
      const storeModel = new StoresListItemModel();
      storeModel.bindModel(it);

      this.get('stores').push(storeModel)
    })

    this.set('hasItems', this.get('stores').length);
  }
});

module.exports = StoresListModel;